import { NgModule } from '@angular/core';
import { ModalCopyPeriodComponent } from '../component/shared/modal-copy-period/modal-copy-period.component';
import { SharedComponentsModule } from '../../shared/module/shared-components.module';
import { ModalDeletePeriodComponent } from '../component/shared/modal-delete-period/modal-delete-period.component';
import {
  ModalFpBulkUploadComponent,
} from '../component/fund-performances/modal/modal-fp-bulk-upload/modal-fp-bulk-upload.component';
import {
  ModalFpBulkUploadWrapperComponent,
} from '../component/fund-performances/modal/template-modal-fp-bulk-upload/modal-fp-bulk-upload-wrapper.component';
import {
  FpCommitmentAllocationComponent,
  ModalExpensesPredictionComponent,
} from '../component/fund-performances/modal/modal-fund-performance-update';
import {
  ModalFundPerformanceUpdateComponent,
} from '../component/fund-performances/modal/modal-fund-performance-update/modal-fund-performance-update.component';
import {
  CarryCombinedInputsComponent,
} from "../../shared/component/input/carry-combined-inputs/carry-combined-inputs.component";

@NgModule({
  declarations: [
    ModalCopyPeriodComponent,
    ModalDeletePeriodComponent,
    ModalFpBulkUploadComponent,
    ModalFpBulkUploadWrapperComponent,
    FpCommitmentAllocationComponent,
    ModalFundPerformanceUpdateComponent,
    ModalExpensesPredictionComponent,
  ],

  imports: [
    SharedComponentsModule,
    CarryCombinedInputsComponent,
  ],

  exports: [
    ModalCopyPeriodComponent,
    ModalDeletePeriodComponent,
    ModalFpBulkUploadComponent,
    ModalFpBulkUploadWrapperComponent,
    FpCommitmentAllocationComponent,
    ModalFundPerformanceUpdateComponent,
    ModalExpensesPredictionComponent,
  ],
})
export class FundPerformanceSharedModule { }
